import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  FormControl,
  FormLabel,
  Grid2 as Grid,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import useFilter from "./useFilter";
import { AdmAuth, Yn } from "@/constants/code";
import { AdmListRequestDto } from "@/dto/AdmDto";

export type FilterProps = {
  values: AdmListRequestDto;
  onChange: (values: AdmListRequestDto) => void;
  onReset: () => void;
};

export const Filter = (props: FilterProps) => {
  const { values, onChange, onReset } = props;
  const {
    formValues,
    handleSearch,
    handleReset,
    handleKeywordChange,
    handleAdmAuthChange,
    handleUseYnChange,
  } = useFilter(values, onChange, onReset);

  return (
    <Card variant={"outlined"}>
      <CardHeader
        title={"검색"}
        titleTypographyProps={{
          variant: "h6",
          fontWeight: 600,
        }}
      />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <FormControl fullWidth>
              <FormLabel>권한</FormLabel>
              <Select
                multiple
                value={formValues.admAuth}
                onChange={(event: SelectChangeEvent<typeof values.admAuth>) => {
                  const {
                    target: { value },
                  } = event;

                  handleAdmAuthChange(value as AdmAuth[]);
                }}
                input={<OutlinedInput />}
                renderValue={(selected) => {
                  if (!selected || selected.length === 0) {
                    return "전체";
                  }

                  if (
                    selected.includes(AdmAuth.Super) &&
                    selected.includes(AdmAuth.Admin)
                  ) {
                    return "전체";
                  } else {
                    if (selected.includes(AdmAuth.Super)) {
                      return "슈퍼 관리자";
                    }
                    if (selected.includes(AdmAuth.Admin)) {
                      return "일반 관리자";
                    }
                  }

                  return "권한을 선택해주세요";
                }}
              >
                <MenuItem value={AdmAuth.Super}>
                  <ListItemText
                    primary={"슈퍼 관리자"}
                    slotProps={{
                      primary: { fontWeight: 500 },
                    }}
                  />
                </MenuItem>
                <MenuItem value={AdmAuth.Admin}>
                  <ListItemText
                    primary={"일반 관리자"}
                    slotProps={{
                      primary: { fontWeight: 500 },
                    }}
                  />
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <FormControl fullWidth>
              <FormLabel>사용여부</FormLabel>
              <Select
                multiple
                value={formValues.useYn}
                onChange={(event: SelectChangeEvent<typeof values.useYn>) => {
                  const {
                    target: { value },
                  } = event;

                  handleUseYnChange(value as Yn[]);
                }}
                renderValue={(selected) => {
                  if (!selected || selected.length === 0) {
                    return "전체";
                  }

                  if (selected.includes(Yn.Y) && selected.includes(Yn.N)) {
                    return "전체";
                  } else {
                    if (selected.includes(Yn.Y)) {
                      return "사용";
                    }
                    if (selected.includes(Yn.N)) {
                      return "미사용";
                    }
                  }

                  return "사용여부를 선택해주세요";
                }}
              >
                <MenuItem value={Yn.Y} selected={values.useYn!.includes(Yn.Y)}>
                  <ListItemText
                    primary={"사용"}
                    slotProps={{
                      primary: { fontWeight: 500 },
                    }}
                  />
                </MenuItem>
                <MenuItem value={Yn.N} selected={values.useYn!.includes(Yn.N)}>
                  <ListItemText
                    primary={"미사용"}
                    slotProps={{
                      primary: { fontWeight: 500 },
                    }}
                  />
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <FormControl fullWidth>
              <FormLabel>검색어</FormLabel>
              <OutlinedInput
                placeholder="검색어를 입력해주세요"
                value={formValues.keyword}
                onChange={(event) => {
                  const {
                    target: { value },
                  } = event;

                  handleKeywordChange(value);
                }}
              />
            </FormControl>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end" }}>
        <Button variant={"text"} disableElevation onClick={handleSearch}>
          Search
        </Button>
        <Button
          variant={"text"}
          color={"error"}
          disableElevation
          onClick={handleReset}
        >
          Reset
        </Button>
      </CardActions>
    </Card>
  );
};
